export default {
  home: 'Startseite',        // Главная
  developers: 'Entwickler',  // Застройщики
  agencies: 'Agenturen',     // Агентства
  properties: 'Immobilien',  // Объекты недвижимости
  login: 'Anmelden',         // Войти
  registration: 'Registrieren' // Регистрация
}